/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelJobClassCodeLookup.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/job-class-code-lookup";

export class AutogenModelJobClassCodeLookup<RowType extends ModelRow> extends Endpoint<RowType, RowJobClassCodeLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowJobClassCodeLookup extends ModelRow<RowJobClassCodeLookupFields> {
	constructor(values?: Partial<RowJobClassCodeLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowJobClassCodeLookupFields {
	company_id: string;
	descr: string;
	id: string;
}

